module.exports = __webpack_public_path__ + "img/banner8.6148a83c.jpg";